import React from 'react';
import { Text } from '@mantine/core';
import styles from './Navbar.module.css';

export type NavbarTextProps = {
  title: string;
};

const NavbarText = (props: NavbarTextProps) => {
  return (
    <Text c="#737373" my={6} className={styles.label}>
      {props.title}
    </Text>
  );
};

export default NavbarText;
